function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import cn from 'classnames';
import React, { forwardRef, HTMLAttributes } from 'react';
import { Skeleton } from '../Skeleton';
import { ProductHeader } from './ProductHeader';
import { ProductFooter } from './ProductFooter';
import { ProductBody } from './ProductBody';
require("./Product.css");
var styles = {
  "ProductRoot": "Product-module-ProductRoot_24E",
  "ProductHeader": "Product-module-ProductHeader_zOD",
  "ProductBody": "Product-module-ProductBody_hFy",
  "ProductFooter": "Product-module-ProductFooter_3Rv",
  "Skeleton": "Product-module-Skeleton_1Bx",
  "Column": "Product-module-Column_2-x",
  "SkeletonTitle": "Product-module-SkeletonTitle_3MD",
  "SkeletonText": "Product-module-SkeletonText_3UG",
  "Row": "Product-module-Row_2AA",
  "SkeletonFullWidth": "Product-module-SkeletonFullWidth_229",
  "SkeletonSizeX": "Product-module-SkeletonSizeX_t04",
  "SkeletonSizeM": "Product-module-SkeletonSizeM_3qs",
  "SkeletonSizeL": "Product-module-SkeletonSizeL_lr0",
  "SkeletonSizeXL": "Product-module-SkeletonSizeXL_1lK",
  "SkeletonImage": "Product-module-SkeletonImage_3M2",
  "SkeletonTextSmall": "Product-module-SkeletonTextSmall_3r4",
  "SkeletonPrice": "Product-module-SkeletonPrice_3gb",
  "SkeletonBonus": "Product-module-SkeletonBonus_1tB",
  "SkeletonButton": "Product-module-SkeletonButton_s5a"
};
export let DirectionType;
(function (DirectionType) {
  DirectionType["column"] = "Column";
  DirectionType["row"] = "Row";
})(DirectionType || (DirectionType = {}));
export const ProductRoot = /*#__PURE__*/forwardRef(function ProductRoot(props, ref) {
  const {
    direction = 'column',
    children,
    className,
    isLoading = false,
    ...rest
  } = props;
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", _extends({
      ref: ref
    }, rest, {
      className: cn(styles.ProductRoot, className, styles[DirectionType[direction]])
    }), /*#__PURE__*/React.createElement(ProductHeader, {
      className: styles.Skeleton
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonImage
    })), /*#__PURE__*/React.createElement(ProductBody, {
      className: styles.Skeleton
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonTitle
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonText
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonText
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: cn(styles.SkeletonText, styles.SkeletonTextSmall)
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonText
    })), /*#__PURE__*/React.createElement(ProductFooter, {
      className: styles.Skeleton
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonPrice
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonPrice
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonBonus
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.SkeletonButton
    }), /*#__PURE__*/React.createElement(Skeleton, null)));
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest, {
    className: cn(styles.ProductRoot, className, styles[DirectionType[direction]])
  }), children);
});